import React, { FC, useState } from 'react'

import { SlideIn } from '../../Animation/SlideIn'
import { Button } from '../../Button'
import { Overlay } from '../../Overlay'
import { AccountSettingsConnectorOverlay } from './AccountSettingsConnectorOverlay'
import { ModalContent } from './types'

export const AccountSettingsOverlay: FC<ModalContent> = ({
  setSettings,
  isConnected,
  connectors,
  connect,
  disconnect,
  connector,
}) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <div className="grid items-center grid-flow-col px-1 py-2 font-light select-none lg:text-xxs text-xxxs tracking-default text-end">
        Connected with&nbsp;
        {connector?.id === 'injected'
          ? 'MetaMask'
          : connector?.id === 'walletConnect'
          ? 'WalletConnect'
          : connector?.id}
        <Button
          size="nobase"
          variant="outlined"
          color="default"
          className="px-2 py-1 mx-2 bg-gray-400 border-gray-300 lg:text-sm text-xxs text-primary rounded-xl"
          onClick={() => {
            setOpen(true)
          }}
        >
          Change
        </Button>
      </div>
      <SlideIn.FromLeft show={open} onClose={() => setOpen(false)}>
        <Overlay.Content className="!bg-slate-800">
          <Overlay.Header
            className="bg-gray-500"
            onClose={() => setOpen(false)}
            title="Change Wallet"
          />
          <div className="px-1 py-1">
            <AccountSettingsConnectorOverlay
              setSettings={setSettings}
              isConnected={isConnected}
              connectors={connectors}
              connect={connect}
              disconnect={disconnect}
              connector={connector}
            />
          </div>
        </Overlay.Content>
      </SlideIn.FromLeft>
    </>
  )
}
